export function localeFromHostname(hostname: string): "pl" | "en" {
  if (hostname === "pracownik.ai" || hostname.endsWith(".pracownik.ai")) {
    return "pl";
  }
  return "en";
}

export function brandFromLocale(locale: "pl" | "en"): "pracownik.ai" | "teammember.ai" {
  return locale === "pl" ? "pracownik.ai" : "teammember.ai";
}

export function appHostFromDomain(
  domain: "pracownik.ai" | "teammember.ai",
): "app.pracownik.ai" | "app.teammember.ai" {
  return domain === "teammember.ai" ? "app.teammember.ai" : "app.pracownik.ai";
}
